<div style="height:100%;"
  [matTooltip]="tooltip"
  [matTooltipShowDelay]="tooltipShowDelay"
  [matTooltipDisabled]="elementForConstant!=='div'"
  [ngClass]="auto_class"
  [ngStyle]="formats?.style"
  [appFloatingInput]="show_full && (elementForConstant==='textarea' || elementForConstant==='input') && data_type==='string'"
  [FloatingInputValue]="constant_value ? stringValue(constant_value) : ''"
  (FloatingInputValueChanged)="constantChanged($event);"
  (FloatingInputMouseLeave)="hideFull($event)"
  [appFitContent]="constant_value"
  [allowFit]="formats?.allow_fit"
  [className]="data_type"
  class="lock-indicator"
  [dblClickCopy]="disabled?stringValue(constant_value):null"
  >
  @if (locked) {
    <i (click)="lockClicked()" class="fa fa-lock lock-indicator-icon"
    [style.cursor]="can_unlock? 'pointer':'default'"></i>
  }
  @if (elementForConstant==='date-time-picker') {
    <date-time-picker
      (date_changed)="constantChangedComplete($event);"
      [input_date]="constant_value"
      [disabled]="disabled"
      (click)="$event.stopPropagation()"
      [appFitContent]="constant_value"
      [allowFit]="allow_fit"
      >
    </date-time-picker>
  }

  <!--div to show full value on mouseover for disabled values (which don't have a mouseover event-->
  @if (elementForConstant==='div') {
    <div
      class="float disabled-float">
      <div
        [hoverDelay]="500"
        (mouseIn)="mouseover=true;"
        (mouseOut)="mouseover=false;"
        [textContent]="!mouseover ? (constant_value | formatNumber:formats?.decimals:show_sig | thousandsSeparate) :
       constant_value"></div>
    </div>
  }

  @if (elementForConstant==='input') {
    <input
      (change)="changeComplete();"
      (ngModelChange)="constantChanged($event);"
      (focus)="is_focussed = true;"
      (focusout)="is_focussed = false;"
      [matTooltip]="(data_type==='float' && !is_focussed && !mouseover && constant_value != null)
                      ? (constant_value | formatNumber:formats?.decimals:show_sig | thousandsSeparate) : constant_value"
      [matTooltipShowDelay]="tooltipShowDelay"
      [hoverDelay]="500"
      (mouseIn)="mouseover=true;"
      (mouseOut)="mouseover=false;"
      (click)="showFull()"
      [ngModel]="(data_type==='float' && !is_focussed && !mouseover && constant_value != null)
                      ? (constant_value | formatNumber:formats?.decimals:show_sig | thousandsSeparate) : constant_value"
      [disabled]="disabled"
      [type]="(data_type!=='float' || !is_focussed) ?'text':'number'"
      [placeholder]="placeholder"
      [className]="data_type"
      [ngClass]="{'showing-placeholder' : !constant_value}"
      (mousewheel)="$event.preventDefault();"
      step="any"
      tabindex="1"/>
  }

  @if (elementForConstant==='textarea') {
    <textarea
      (change)="changeComplete();"
      (ngModelChange)="constantChanged($event);"
      (focus)="is_focussed = true;"
      (focusout)="is_focussed = false;"
      (mouseenter)="mouseover=true;"
      (mouseleave)="mouseover=false;"
      (click)="showFull()"
      [ngModel]="constant_value"
      [disabled]="disabled"
      [placeholder]="placeholder"
      [className]="data_type"
      [matTooltip]="tooltip"
      [matTooltipShowDelay]="tooltipShowDelay"
      [attr.rows]="textarea_rows"
      step="any"
      matTooltipPosition="above"
    tabindex="1"></textarea>
  }
  @if (show_ellipsis) {
    <div class="textarea-ellipsis" (click)="showFull($event)"><i class="fas fa-ellipsis"></i></div>
  }

  @if ((elementForConstant==='mat-select')) {
    <select-filter
      (constant_changed)="constantChangedComplete($event);"
      [options]="constant_property.attributes.json"
      [disabled]="disabled"
      [is_user_options]="data_type=='user'"
      [is_user_group_options]="data_type=='user_group'"
      [is_account_options]="data_type=='account'"
      [modelValue]="constant_value"
      [allow_fit]="allow_fit"
      [filter_compare]="jsonFilterCompare"
      [conditional_formats]="conditional_formats"
      [placeholder]="placeholder"
      [tab_index]="1"
      [classes]="'fill show-select-arrow'">
    </select-filter>
  }

  <!--For related type values-->
  @if ((elementForConstant==='list')) {
    <select-many-filter
      [options]="getRelatedComponentTypeOptions()"
      [modelValue]="constant_value"
      [disabled]="disabled"
      [disableItemFunction]="disableItem.bind(this)"
      [allow_fit]="allow_fit"
      [filter_compare]="jsonFilterCompare"
      [conditional_formats]="conditional_formats"
      [placeholder]="placeholder"
      [tab_index]="1"
      [classes]="'fill show-select-arrow'"
      [panelClass]="'constant-field-disabled'">
    </select-many-filter>
  }
  <!-- Render nothing for empty list values -->
  @if ((elementForConstant==='none')) {
    <div class="empty-list-value"></div>
  }
</div>
